import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-50bb5f7f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "mb-3"
};
var _hoisted_2 = {
  class: "pb-2"
};
var _hoisted_3 = {
  key: 0,
  class: "sources"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_5 = {
  key: 1,
  class: "sources"
};
import { ref, computed } from "vue";
import { LockOpenOutline } from "@vicons/ionicons5";
import { orderBy } from "lodash";
import { useIsMobile } from "@/utils/reactive";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    mkey: null,
    loaded: null,
    title: {
      default: "Sources"
    },
    error: {
      default: "The requested data is currently inaccessible."
    },
    count: {
      default: 3
    }
  },
  emits: ["open", "closed", "fetched", "retry"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var isMobile = useIsMobile();
    var LoaderState = LoaderStateEnum;
    var loader = ref(props.loaded ? LoaderStateEnum.Loaded : LoaderStateEnum.Loading);
    var sources = ref(props.loaded);
    var show = ref(false);
    var ordered = computed(function () {
      return orderBy(sources.value, function (s) {
        return s.views;
      }, "desc");
    });
    var key = computed(function () {
      return props.mkey.replace(/\s+/g, "-");
    });

    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$http$get, resources;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader.value = LoaderStateEnum.Loading;
                _context.prev = 1;
                _context.next = 4;
                return http.get("/messages/sources", {
                  params: {
                    key: props.mkey
                  }
                });

              case 4:
                _yield$http$get = _context.sent;
                resources = _yield$http$get.data;
                sources.value = resources;
                emit("fetched", resources);
                loader.value = LoaderStateEnum.Loaded;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                loader.value = LoaderStateEnum.Failed;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    var retry = function retry() {
      emit("retry");
      load();
    };

    var onOpened = function onOpened() {
      emit("open");
      if (!props.loaded && !sources.value) load();
    };

    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_a = _resolveComponent("n-a");

      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_tag = _resolveComponent("n-tag");

      var _component_n_tooltip = _resolveComponent("n-tooltip");

      var _component_n_empty = _resolveComponent("n-empty");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _component_n_modal = _resolveComponent("n-modal");

      return _openBlock(), _createElementBlock(_Fragment, null, [_renderSlot(_ctx.$slots, "action", {
        trigger: function trigger() {
          return show.value = true;
        }
      }), _createVNode(_component_n_modal, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        "auto-focus": false,
        preset: "card",
        title: __props.title,
        onAfterEnter: onOpened,
        onAfterLeave: _cache[1] || (_cache[1] = function ($event) {
          return emit('closed');
        }),
        class: "sources-modal header-pb-0"
      }, {
        default: _withCtx(function () {
          var _sources$value;

          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_n_text, {
            depth: "3"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(key)), 1)];
            }),
            _: 1
          })]), _createElementVNode("div", _hoisted_2, [loader.value !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [loader.value !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [((_sources$value = sources.value) === null || _sources$value === void 0 ? void 0 : _sources$value.length) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ordered), function (source) {
            return _openBlock(), _createElementBlock("div", {
              class: "source d-flex flex-row align-items-start",
              key: source.value
            }, [_createVNode(_component_n_a, {
              href: source.value,
              target: "_blank",
              class: "me-2 source-target"
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(source.value), 1)];
              }),
              _: 2
            }, 1032, ["href"]), _createVNode(_component_n_tooltip, {
              trigger: "hover",
              placement: "right",
              disabled: _unref(isMobile)
            }, {
              trigger: _withCtx(function () {
                return [_createVNode(_component_n_tag, {
                  size: "small",
                  class: "rounded-2"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_n_icon, null, {
                      default: _withCtx(function () {
                        return [_createVNode(_unref(LockOpenOutline), {
                          class: "align-top"
                        })];
                      }),
                      _: 1
                    }), _createTextVNode(" " + _toDisplayString(source.views), 1)];
                  }),
                  _: 2
                }, 1024)];
              }),
              default: _withCtx(function () {
                return [_createTextVNode(" This message has been decoded " + _toDisplayString(source.views) + " times on this page ", 1)];
              }),
              _: 2
            }, 1032, ["disabled"])]);
          }), 128))])) : _renderSlot(_ctx.$slots, "empty", {
            key: 1
          }, function () {
            return [_createVNode(_component_n_empty, {
              description: "This message hasn't been seen anywhere yet."
            })];
          })], 64)) : (_openBlock(), _createBlock(_component_n_result, {
            key: 1,
            status: "error",
            description: __props.error
          }, {
            footer: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                onClick: retry
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["description"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.count, function (n) {
            return _openBlock(), _createBlock(_component_n_skeleton, {
              class: "source source-skeleton py-1",
              key: n
            });
          }), 128))]))])];
        }),
        _: 3
      }, 8, ["show", "title"])], 64);
    };
  }
});